// Stage 71 — programmatic navigation for command handlers.
//
// app.ts owns client-side routing: it intercepts real <a href> clicks (the
// composed-path interceptor) and calls its private _navigate(). Command
// handlers can't reach that, so they dispatch a window CustomEvent — the same
// convention the codebase already uses for cross-cutting signals
// (cos:auth:logout, cos:chat-*). app.ts listens for `cos:navigate` and routes
// it through the exact same _navigate() path real links use.

export const NAVIGATE_EVENT = 'cos:navigate';

export interface NavigateDetail {
	href: string;
}

/** Client-side navigate to an in-app path (e.g. "/partners/123"). */
export function navigate(href: string): void {
	window.dispatchEvent(
		new CustomEvent<NavigateDetail>(NAVIGATE_EVENT, { detail: { href } }),
	);
}
